import { render, staticRenderFns } from "./ProgramarCurso.vue?vue&type=template&id=45f0b8e5"
import script from "./ProgramarCurso.vue?vue&type=script&lang=js"
export * from "./ProgramarCurso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports